export default __webpack_public_path__ + "static/media/immolation.ed1e65e2.png";